import { useState, useEffect, type ReactNode, type FormEvent } from 'react';

/**
 * プレビュー(ステージング)専用のパスワードゲート。
 * ビルド時に VITE_PREVIEW_PASSWORD を渡したときだけ有効化され、
 * 正しいパスワードを入れるまでサイト全体を隠す。
 * 本番ビルド(env未設定)では素通し＝一切影響なし。
 */
const PREVIEW_PASSWORD = (import.meta.env.VITE_PREVIEW_PASSWORD as string | undefined) || '';
const STORAGE_KEY = 'lovelark_preview_unlock';

export default function PreviewGate({ children }: { children: ReactNode }) {
  const enabled = PREVIEW_PASSWORD.length > 0;
  const [unlocked, setUnlocked] = useState(!enabled);
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    if (localStorage.getItem(STORAGE_KEY) === PREVIEW_PASSWORD) setUnlocked(true);
  }, [enabled]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (input === PREVIEW_PASSWORD) {
      localStorage.setItem(STORAGE_KEY, PREVIEW_PASSWORD);
      setUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  if (unlocked) return <>{children}</>;

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0f0f10', color: '#fff', fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
      padding: '24px',
    }}>
      <form onSubmit={handleSubmit} style={{
        width: '100%', maxWidth: 360, background: '#18181b', border: '1px solid #2a2a2e',
        borderRadius: 14, padding: 32,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: '0.08em' }}>PREVIEW</div>
          <div style={{ fontSize: 12, color: '#8c8c90', marginTop: 4 }}>関係者向けプレビュー環境</div>
        </div>
        <label style={{ display: 'block', fontSize: 13, color: '#c9c9cc', marginBottom: 8 }}>パスワード</label>
        <input
          type="password"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(false); }}
          autoFocus
          style={{
            width: '100%', boxSizing: 'border-box', padding: '11px 12px', borderRadius: 8,
            border: `1px solid ${error ? '#dc2626' : '#3a3a3f'}`, background: '#0f0f10',
            color: '#fff', fontSize: 14, outline: 'none',
          }}
          placeholder="パスワードを入力"
        />
        {error && <p style={{ fontSize: 12, color: '#f87171', marginTop: 8 }}>パスワードが違います</p>}
        <button type="submit" style={{
          width: '100%', marginTop: 16, padding: '11px', borderRadius: 8, border: 'none',
          background: '#fff', color: '#111', fontSize: 14, fontWeight: 600, cursor: 'pointer',
        }}>
          表示する
        </button>
      </form>
    </div>
  );
}
